<template>
  <span class="price">
    <span class="price__amount">{{ amount }}</span>
    <span class="price__unit" v-if="cadence">/ {{ cadence }}</span>
  </span>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    amount: { required: true, type: String },
    cadence: { required: false, type: String },
  },
  setup() {},
})
</script>

<style lang="scss" scoped>
.price {
  font-size: 1.8rem;
  line-height: 1.1;
  text-align: center;
}

.price__amount,
.price__unit {
  display: block;
}

.price__unit {
  font-size: 0.5em;
}
</style>